import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {TenantsListHeader} from './components/header/TenantsListHeader'
import {TenantsTable} from './table/TenantsTable'
import {TenantEditModal} from './tenant-edit-modal/TenantEditModal'
import { KTCard } from '../../../../_metronic/helpers'
// import {KTCard} from '../../../../../_metronic/helpers'

const TenantsList = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      <KTCard>
        <TenantsListHeader />
        <TenantsTable />
      </KTCard>
      {itemIdForUpdate !== undefined && <TenantEditModal />}
    </>
  )
}

const TenantsListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <TenantsList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {TenantsListWrapper}
